import React, { useState, useEffect } from "react";
import '../styles/header.css';

const HeaderComponent = () => {
  const messages = [
    "Create your account to get full features!",
    "We're on social media, find us in collector's menu!",
  ];
  
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 5000); // 4 seconds to change the message
  
    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return (
      <div className="header-container">
              <div className="item-divider-long full-width" />

      <div id="header">
        <h1 className="fade">{messages[currentMessageIndex]}</h1>
      </div>
      <div className="item-divider-long full-width" />
      </div>
  );
}

export default HeaderComponent;